export default __webpack_public_path__ + "static/media/pending.14ad6c3e.svg";